<template>
  <header
    class="bq-header"
    :class="{ mobile: isMobile, scroll: scrollClass }"
    ref="header"
  >
    <div class="bq-header-wrap">
      <a
        class="bq-logo"
        :class="!isMobile ? 'bq-logo-pc' : ''"
        href="/"
        v-if="project_env === 'website_v3'"
      >
        <img :src="logo.murl" :alt="logo.title" v-if="isMobile" />
        <img :src="logo.url" :alt="logo.title" v-else />
      </a>

      <bq-nav :lists="getList" @active="itemSelect" />
    </div>
  </header>
</template>

<script>
import BqNav from '../Nav';
import { logo, navList } from './header';
// import { isWirelessDevice } from '../../../utils/utils';
import { project_env } from '../../../defaultSettings';

const navigation = {
  website_v3: navList,
};

export default {
  name: 'BQHeader',

  data() {
    return {
      isMobile: false,
      logo,
      project_env,
      bannerHeight: 485 - 90,
      disIndex: true,
      scrollClass: false,
    };
  },

  components: {
    BqNav,
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  mounted() {
    const { path } = this.$route;
    // 开启滚动监听
    path === '/' && window.addEventListener('scroll', this.handleScroll, true);
  },

  computed: {
    getList() {
      const lists = !this.isMobile
        ? navigation[project_env].slice(0, 5).reverse()
        : project_env === 'website_v3'
        ? navigation[project_env].slice(1)
        : navigation[project_env].slice(0, 2);

      return lists;
    },
  },

  methods: {
    itemSelect(id) {
      console.log(id);
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.scrollClass = true;
      } else {
        this.scrollClass = false;
      }
    },
  },
  watch: {},
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
